module.exports = __webpack_public_path__ + "img/search-by-zip-black.5c226a8c.png";